import type { ProjectSchema } from '~/@pages_investing/projects/_project_types/project.types'
import { eurToCents } from '~/@lib/utils/money.utils'

function isStageFullyFunded(project: ProjectSchema): boolean {
  return eurToCents(project.amountTarget - project.amountCurrent) <= 0
}

export { isStageFullyFunded }
